import * as React from 'react';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { ToneCardCSSStyle } from '../../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { ToneRowOptionsPrivilage, ToneRowOptionsPrivilageImpl } from '../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { GridPaginationListViewModelImpl } from '../../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';
import { ProfileTuneCardComponent } from './profiletunecardcomponent';
import { ProfileTuneCardCSSStyleImpl } from './profiletunecardcssstyle';
import { ProfileTuneEvenCardCSSStyleImpl } from './profiletuneevencardcssstyle';
import { ToneCardPlayerCSSStyleImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardplayercss';
import { PlayerTuneCardPlayerCSSStyleImpl } from './profiletunecardplayercssstyle';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { ProfileToneMobileCardPlayerCSSStyleImpl } from './profiletonecardmobplayercssstyle';

export class ProfileTuneRowOptionsImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setLike(true);
        this.setGift(true);
        this.setShare(true);
        this.setBuy(true);
        this.setDelete(false);
        this.setTellAFriend(true);
        this.setAddWishList(true);
        this.setPlay(false);
        this.setIsToneSelect(true);
        this.setSettings(false);
        this.setAction(true);
    }
}


export class ProfileTuneViewModelImpl extends GridPaginationListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    private toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
    private playerCSSStyle: ToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;
  
    constructor(offset: string, context: BaseContext, private marginTop: string, private audioPlayerWithProgress: AudioPlayerWithProgress)
    {
        super(offset, context);
        
        this.toneOddCardCSSStyle = new ProfileTuneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ProfileTuneEvenCardCSSStyleImpl(context);
        this.toneRowOptionsPrivilage = new ProfileTuneRowOptionsImpl();

        this.playerCSSStyle = new PlayerTuneCardPlayerCSSStyleImpl(context);
        this.playerMobileCSSStyle = new ProfileToneMobileCardPlayerCSSStyleImpl(context);
    }

    // setTitle(title: string)
    // {
    //     this.title = title;
    // }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <ProfileTuneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} cardStyle={this.toneOddCardCSSStyle} key={position}  context={this.getContext()} toneDto={t}  position={position} audioPlayerWithProgress={this.audioPlayerWithProgress as AudioPlayerWithProgressImpl} />;

        }
        else
        {
            return <ProfileTuneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} cardStyle={this.toneEvenCardCSSStyle} key={position} context={this.getContext()} toneDto={t}  position={position} audioPlayerWithProgress={this.audioPlayerWithProgress as AudioPlayerWithProgressImpl} />;

        }
    }

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/profiletunecard/profiletuneviewmodel.tsx